import router from '..'
import { ROUTES_NAMES } from '../routesNames'
import { useSettingsStore } from '@/stores/settings/settingsStore'

const settingsRouteNames = new Set<string>([
  ROUTES_NAMES.settings,
  ROUTES_NAMES.settingsLanguage,
  ROUTES_NAMES.settingsPrint,
  ROUTES_NAMES.settingsLastTickets,
])

const settingsUnsavedChangesGuard = () => {
  const settingsStore = useSettingsStore()

  router.beforeEach((to, from) => {
    const isLeavingSettings = settingsRouteNames.has(from.name)
    const isStayingInSettings = settingsRouteNames.has(to.name)

    if (!isLeavingSettings || isStayingInSettings) {
      return true
    }

    if (!settingsStore.isFormChanged) {
      return true
    }

    if (settingsStore.isUnsavedSettingsModalOpen) {
      settingsStore.isUnsavedSettingsModalOpen = false
      return true
    }

    settingsStore.pendingRoute = to.fullPath
    settingsStore.isUnsavedSettingsModalOpen = true
    return false
  })
}

export { settingsUnsavedChangesGuard }
